<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title"><strong>Add Branch Tax</strong></h3>
  <div class="header-actions">
    <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;" (click)="minimise = !minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body" [hidden]="minimise">
  <div class="container">
    <!-- Loader -->
    @if (showFormLoader) {
<div class="formLoader">
      <i class="fa fa-spinner fa-spin gt-refresh"></i>
    </div>
}

    @if (!showFormLoader) {
<div>
      <!-- Entity Selection Row -->
      <div class="row">
        <div class="col-md-6">
          <label>Entity</label>
          <div class="custom-select-container">
            <div class="custom-select-wrapper">
              <input type="text" 
                     class="form-control custom-select-input" 
                     [(ngModel)]="entitySearchTerm"
                     (input)="filterEntities()"
                     (click)="onEntityInputFocus()"
                    >
              <span class="custom-select-caret" (click)="toggleEntityDropdown()">
                <i class="fa fa-caret-down"></i>
              </span>
            </div>
            @if (showEntityDropdown && filteredCodeCombinationData.length > 0) {
<div class="custom-select-dropdown">
              @for (cc of filteredCodeCombinationData; track $index) {
<div class="custom-select-item" 
                  
                   (mousedown)="selectEntity(cc)">
                {{ cc.VALUE }}
              </div>
}
            </div>
}
            @if (showEntityDropdown && filteredCodeCombinationData.length === 0 && codeCombinationData.length === 0) {
<div class="custom-select-dropdown">
              <div class="custom-select-item no-results">
                Loading entities...
              </div>
            </div>
}
            @if (showEntityDropdown && filteredCodeCombinationData.length === 0 && codeCombinationData.length > 0) {
<div class="custom-select-dropdown">
              <div class="custom-select-item no-results">
                No matching entities found
              </div>
            </div>
}
          </div>
        </div>
        @if (isAmendedScenario) {
<div class="col-md-6">
          <label>Issue Id</label>
          <select class="form-control" 
                  [(ngModel)]="formData.selectedIssue" 
                  style="height: 30px; width: 380px;">
            @for (issueData of issueDropdownData; track $index) {
<option 
                    [value]="issueData.issue_id">
              {{ issueData.issue_short_desc }}
            </option>
}
          </select>
        </div>
}
      </div>

      <!-- Radio Buttons for Creditable/Non-Creditable -->
      <div class="radio-row" style="text-align: center; margin-top: 20px;">
        <table style="margin: 0 auto;">
          <tr>
            <td>
              <label>
                <input type="radio" 
                       [(ngModel)]="formData.panel" 
                       [value]="true"
                       (change)="onRadioChange()">
                Creditable Tax
              </label>
            </td>
            <td style="width: 50px;">&nbsp;</td>
            <td>
              <label>
                <input type="radio" 
                       [(ngModel)]="formData.panel" 
                       [value]="false"
                       (change)="onRadioChange()">
                TB Amount Not Creditable
              </label>
            </td>
          </tr>
        </table>
      </div>

      <!-- Creditable Tax Panel -->
      @if (formData.enableCreditablePanel) {
<div style="margin-top: 20px;">
        <table class="table table-striped blue" style="text-align: left; width: 100%;">
          <thead>
            <tr>
              <th colspan="5" style="text-align: center;">Creditable Tax</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Basket</td>
              <td>
                <select class="form-control" 
                        [(ngModel)]="formData.selectedBasketCatg" 
                        style="height: 30px; width: 380px;">
                  @for (creditable of basketCatgData; track $index) {
<option 
                          [value]="creditable.CODE_KEY">
                    {{ creditable.CODE_DISP_DESC }}
                  </option>
}
                </select>
              </td>
              <td></td>
              <td>Branch Taxes per Trial Balance</td>
              <td>
                <input type="text" 
                       class="form-control" 
                       [(ngModel)]="formData.branchTaxTrailBalanceAmt"
                       disabled
                       style="height: 30px; width: 380px;">
              </td>
            </tr>
            <tr>
              <td>Branch Tax LEID</td>
              <td>
                <select class="form-control" 
                        [(ngModel)]="formData.genLeid"
                        (change)="changeLeCountry()"
                        style="height: 30px; width: 380px;">
                  <option value="">-- Select --</option>
                  @for (generatedLeid of formData.generatedLeidDropDown; track $index) {
<option 
                          [value]="generatedLeid.LEID_LABEL">
                    {{ generatedLeid.LEID_VALUE }}
                  </option>
}
                </select>
              </td>
              <td></td>
              <td>Total Branch Tax</td>
              <td>
                <input type="text" 
                       class="form-control" 
                       [(ngModel)]="formData.totalBranchTaxes"
                       disabled
                       style="height: 30px; width: 380px;">
              </td>
            </tr>
            <tr>
              <td>Country</td>
              <td>
                <select class="form-control" 
                        [(ngModel)]="formData.selectedCountryDesc"
                        style="height: 30px; width: 380px;">
                  <option value="">-- Select --</option>
                  @for (c of countryData; track $index) {
<option 
                          [value]="c.CODE_DISP_DESC">
                    {{ c.CODE_DISP_DESC }}
                  </option>
}
                </select>
              </td>
              <td></td>
              <td>Unreconciled Amt</td>
              <td>
                <input type="text" 
                       class="form-control" 
                       [(ngModel)]="formData.variance"
                       disabled
                       style="height: 30px; width: 380px;">
              </td>
            </tr>
            <tr>
              <td>Branch Tax</td>
              <td>
                <input type="number" 
                       class="form-control" 
                       [(ngModel)]="formData.creditTaxAmt"
                       style="height: 30px; width: 380px;">
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>Applicable Year</td>
              <td>
                <select class="form-control" 
                        [(ngModel)]="formData.applicableYearKey"
                        style="height: 30px; width: 380px;">
                  @for (creditable of filteredTaxYearForCreditable; track $index) {
<option 
                          [value]="creditable.CODE_KEY">
                    {{ creditable.CODE_DISP_DESC }}
                  </option>
}
                </select>
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>Explain why Branch Tax LEID is US entity</td>
              <td>
                <textarea class="form-control" 
                          [(ngModel)]="formData.explainUsEntity"
                          [disabled]="formData.selectedBranchTaxLEID_Orgnl_CountryKey != countryUS[0]?.CODE_KEY"
                          style="height: 50px; width: 380px; overflow: scroll; resize: vertical;"
                          maxlength="498"></textarea>
                <label style="font-weight: normal; font-size: x-small; color: gray;">Max length 500</label>
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
}

      <!-- Non-Creditable Tax Panel -->
      @if (formData.enableNonCreditablePanel) {
<div style="margin-top: 20px;">
        <table class="table table-striped blue" style="text-align: left; width: 100%;">
          <thead>
            <tr>
              <th colspan="5" style="text-align: center;">TB Amount Not Creditable</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Standard Reason Amount is Not Creditable</td>
              <td>
                <select class="form-control" 
                        [(ngModel)]="formData.selectStdReasonCd"
                        (change)="isTaxPriorYear()"
                        style="height: 30px; width: 380px;">
                  <option value="">-- Select --</option>
                  @for (creditable of stdReasonCodeData; track $index) {
<option 
                          [value]="creditable.CODE_KEY">
                    {{ creditable.CODE_DISP_DESC }}
                  </option>
}
                </select>
              </td>
              <td></td>
              <td>Applicable Year</td>
              <td>
                <select class="form-control" 
                        [(ngModel)]="formData.applicableYearKey2"
                        style="height: 30px; width: 380px;">
                  @for (creditable of filteredTaxYearData; track $index) {
<option 
                          [value]="creditable.CODE_KEY">
                    {{ creditable.CODE_DISP_DESC }}
                  </option>
}
                </select>
              </td>
            </tr>
            <tr>
              <td>Amount</td>
              <td>
                <input type="number" 
                       class="form-control" 
                       [(ngModel)]="formData.nonCrdBrAmount"
                       style="height: 30px; width: 380px;">
              </td>
              <td></td>
              <td>Unreconciled Amt</td>
              <td>
                <input type="text" 
                       class="form-control" 
                       [(ngModel)]="formData.openVariance"
                       disabled
                       style="height: 30px; width: 380px;">
              </td>
            </tr>
            @if (formData.isSection909SplitrTax) {
<tr>
              <td>Basket</td>
              <td>
                <select class="form-control" 
                        [(ngModel)]="formData.selectedSplitterBasketCatg"
                        style="height: 30px; width: 380px;">
                  @for (creditable of basketCatgData; track $index) {
<option 
                          [value]="creditable.CODE_KEY">
                    {{ creditable.CODE_DISP_DESC }}
                  </option>
}
                </select>
              </td>
              <td></td>
              <td>Country</td>
              <td>
                <select class="form-control" 
                        [(ngModel)]="formData.selectedSplitterCountryDesc"
                        style="height: 30px; width: 380px;">
                  <option value="">-- Select --</option>
                  @for (c of countryData; track $index) {
<option 
                          [value]="c.CODE_DISP_DESC">
                    {{ c.CODE_DISP_DESC }}
                  </option>
}
                </select>
              </td>
            </tr>
}
            <tr>
              <td>Detailed Reason Amount is Not Creditable</td>
              <td>
                <textarea class="form-control" 
                          [(ngModel)]="formData.detailReason"
                          style="height: 50px; width: 380px; overflow: scroll; resize: vertical;"
                          maxlength="498"></textarea>
                <label style="font-weight: normal; font-size: x-small; color: gray;">Max length 500</label>
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
}

      <!-- Action Buttons -->
      <div class="button-row" style="text-align: right; margin-top: 20px;">
        @if (formData.enableCreditablePanel) {
<div>
          <button class="btn btn-info btn-sm" 
                  type="button" 
                  (click)="saveCreditAmtBranchTaxForm()" 
                  [disabled]="isSaveClicked">
            @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
          </button>
          <button class="btn btn-danger-outline btn-sm" 
                  type="button" 
                  (click)="resetCreditable()">Reset</button>
          <button class="btn btn-warning btn-sm" 
                  type="button" 
                  (click)="cancel()">Cancel</button>
        </div>
}
        @if (formData.enableNonCreditablePanel) {
<div>
          <button class="btn btn-info btn-sm" 
                  type="button" 
                  (click)="saveNonCreditAmtBranchTaxForm()" 
                  [disabled]="isSaveClicked">
            @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
          </button>
          <button class="btn btn-danger-outline btn-sm" 
                  type="button" 
                  (click)="resetNonCreditable()">Reset</button>
          <button class="btn btn-warning btn-sm" 
                  type="button" 
                  (click)="cancel()">Cancel</button>
        </div>
}
      </div>
    </div>
}
  </div>
</div>
